import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { Course } from "@domain/lms/course/course";
import { useCourseFeedbacks } from "@domain/lms/course/hooks";
import { Secondary } from "@ui/components/containers/textBlocks";
import { TitledBlock } from "@ui/components/containers/titledBlock";
import { gap } from "@ui/styles/utils";
import { FeedbackView } from "./feedbackView";

interface CourseFeedbacksProps extends React.HTMLAttributes<HTMLDivElement> {
	course: Course;
}
export const CourseFeedbacks: React.FC<CourseFeedbacksProps> = ({ course, ...htmlProps }) => {
	const { result: feedbacks, loading, fetchMore, totalElements } = useCourseFeedbacks(course.id);

	return (
		<Container {...htmlProps} title={I18n.t("course.feedbacks.title")}>
			<Feedbacks>
				{feedbacks.map((feedback) => (
					<FeedbackView key={feedback.user.id} feedback={feedback} course={course} />
				))}
			</Feedbacks>
			{loading ? (
				<ClipLoader />
			) : totalElements === 0 ? (
				<Secondary>{I18n.t("course.feedbacks.empty")}</Secondary>
			) : (
				totalElements &&
				totalElements > feedbacks.length && <FetchMore onClick={fetchMore}>{I18n.t("post.comment.more")}</FetchMore>
			)}
		</Container>
	);
};

const Container = styled(TitledBlock)``;

const Feedbacks = styled.div`
	width: 100%;
	display: flex;
	align-items: stretch;
	flex-direction: column;
	${gap(28)}
	@media (max-width: 900px) {
		${gap(15)}
	}
`;

const FetchMore = styled.div`
	margin-top: 44px;
	cursor: pointer;
	${({ theme }) => theme.textStyles.tertiary};
`;
